// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o5-0";
export var buttonContainer = "_o5-3";
export var cancelButton = "_o5-4";
export var headerSection = "_o5-6";
export var headerTitle = "_o5-9";
export var messageSideLeft = "_o5-1";
export var messageSideRight = "_o5-2";
export var orderNumberContainer = "_o5-7";
export var orderNumberLabel = "_o5-8";
export var submitButton = "_o5-5";